import styled from 'styled-components';

export const LOGO_TITLE_KEY = 'fhsLogoTitle';

export const StyledLogo = styled.div`
  width: 61px;
  /** Safari/WkWebView doesn't display the image without the height */
  height: 56px;
  display: flex;
  margin-inline-start: 20px;

  @media (min-width: 431px) and (max-width: 1199px) {
    width: 188px;
    height: 48px;
    margin-inline-start: 25px;
  }

  ${Styles.desktopLarge} {
    height: 48px;
    width: 188px;
    margin-inline-start: 25px;
  }
`;
